export default "__VITE_ASSET__557739bf__"